export default {
  systemErrorCode: 570,
  ageListEnumFilter: [
    {
      id: 8,
      nameAr: 'الجميع',
      nameEn: 'All',
      code: 'all',
    },
    {
      id: 1,
      nameAr: 'الاعمار تحت 10',
      nameEn: 'Age Less Than 10',
      code: 'AgeLessThan10',
    },
    {
      id: 2,
      nameAr: 'الاعمار من 11 الى 20',
      nameEn: 'Age 11 To 20',
      code: 'Age11To20',
    },
    {
      id: 3,
      nameAr: 'الاعمار من 21 الى 30',
      nameEn: 'Age 21 To 30',
      code: 'Age21To30',
    },
    {
      id: 4,
      nameAr: 'الاعمار من 31 الى 40',
      nameEn: 'Age 31 To 40',
      code: 'Age31To40',
    },
    {
      id: 5,
      nameAr: 'الاعمار 41 الى 50',
      nameEn: 'Age 41 To 50',
      code: 'Age41To50',
    },
    {
      id: 6,
      nameAr: 'الاعمار من 51 الى 60',
      nameEn: 'Age 51 To 60',
      code: 'Age51To60',
    },
    {
      id: 7,
      nameAr: 'الاعمار فوق 60',
      nameEn: 'Age Older Than 60',
      code: 'AgeOlderThan60',
    },

  ],

  actionTypeFilterOptions: [
    {
      id: 1,
      nameEn: 'All',
      nameAr: 'الكل',
    },
    {
      id: 2,
      nameEn: 'Purchases',
      nameAr: 'مشتريات',
    },
    {
      id: 3,
      nameEn: 'Return',
      nameAr: 'مرتجعات',
    },
  ],

  sortByFilterOptions: [
    {
      id: 1,
      nameEn: 'Vendor Name',
      nameAr: 'اسم المورد',
    },
    {
      id: 2,
      nameEn: 'Quantity Purchased',
      nameAr: 'الكمية المشتراة',
    },
    {
      id: 3,
      nameEn: 'Quantity Returned',
      nameAr: 'الكمية المرتجعة',
    },
    {
      id: 4,
      nameEn: 'Purchases Amount',
      nameAr: 'مبلغ المشتريات',
    },
    {
      id: 5,
      nameEn: 'Returns Amount',
      nameAr: 'مبلغ المرتجعات',
    },
  ],

  sortDirectionFilterOptions: [
    {
      id: 1,
      nameEn: 'Ascending',
      nameAr: 'تصاعدي',
    },
    {
      id: 2,
      nameEn: 'Descending',
      nameAr: 'تنازلي',
    },
  ],

  organizationPerformanceReportConstants: {
    MembershipTotalPayments: 'MembershipTotalPayments',
    MembershipTotalDiscounts: 'MembershipTotalDiscounts',
    MembershipSales: 'MembershipSales',
    ProductSales: 'ProductSales',
    PaymentsCollected: 'PaymentsCollected',
    CashBoxPaymentsCollected: 'CashBoxPaymentsCollected',
    Refunds: 'Refunds',
    Expenses: 'Expenses',
  },
  memberInactivityType: [
    {
      id: 1,
      nameEn: 'All Inactive',
      nameAr: 'الكل',
      code: 'AllInActive',
    },
    {
      id: 2,
      nameEn: 'Never Registered',
      nameAr: 'لم يتم التسجيل مطلقا',
      code: 'NeverRegistered',
    },
    {
      id: 3,
      nameEn: 'Inactive Membership',
      nameAr: 'عضويات غير نشطة',
      code: 'InActiveMembership',
    },
  ],
  checkinGroupingCountReportParameters: [
    {
      id: 0,
      disName: 'None',
      disNameAr: 'غير محدد',
      name: 'None',
      nameAr: 'غير محدد',
      value: 'None',
    },
    {
      id: 3,
      disName: 'Day',
      disNameAr: 'يومي',
      name: 'Day',
      nameAr: 'يومي',
      value: 'Day',
    },
    {
      id: 2,
      disName: 'Week',
      disNameAr: 'اسبوعي',
      name: 'Week',
      nameAr: 'اسبوعي',
      value: 'Week',
    },
    {
      id: 1,
      disName: 'Month',
      disNameAr: 'شهري',
      name: 'Month',
      nameAr: 'شهري',
      value: 'Month',
    },
  ],
  checkinCountReportGroupByParameters: [
    {
      id: 3,
      disName: 'Gender',
      disNameAr: 'الجنس',
      name: 'Gender',
      nameAr: 'الجنس',
      value: 'Gender',
    },
    {
      id: 4,
      disName: 'Age',
      disNameAr: 'العمر',
      name: 'Age periods',
      nameAr: 'الفئة العمرية',
      value: 'Age',
    },
    {
      id: 7,
      disName: 'Branch',
      disNameAr: 'الفرع',
      name: 'Branch',
      nameAr: 'الفرع',
      value: 'Branch',
    },
  ],
  membersCountReportGroupByParameters: [
    {
      id: 1,
      name: 'Active members by membership type',
      disName: 'Membership type',
      disNameAr: 'نوع العضوية',
      nameAr: 'الأعضاء النشطون حسب نوع العضوية',
      value: 'MembershipType',
    },
    {
      id: 2,
      disName: 'Membership status',
      disNameAr: 'حالة العضوية',
      name: 'Membership by status',
      nameAr: 'العضوية حسب الحالة',
      value: 'MembershipStatus',
    },
    {
      id: 3,
      disName: 'Gender',
      disNameAr: 'الجنس',
      name: 'Active members by gender',
      nameAr: 'الأعضاء النشطين حسب الجنس',
      value: 'Gender',
    },
    {
      id: 4,
      disName: 'Age',
      disNameAr: 'العمر',
      name: 'Active members by age',
      nameAr: 'الأعضاء النشطين حسب العمر',
      value: 'Age',
    },
    {
      id: 5,
      disName: 'Start Month',
      disNameAr: 'تاريخ البداية',
      name: 'Active memberships by start date',
      nameAr: 'العضويات النشطة حسب تاريخ البدء',
      value: 'MembershipStartDate',
    },
    {
      id: 6,
      disName: 'End Month',
      disNameAr: 'تاريخ الانتهاء',
      name: 'Active memberships by end date',
      nameAr: 'العضويات النشطة بحلول تاريخ الانتهاء',
      value: 'MembershipEndDate',
    },
  ],
  gatesDeviceType: [
    {
      id: 1,
      name: 'ZKT SA20',
      value: 'ZKTSA20',
    },
    {
      id: 2,
      name: 'ZKT TF1700',
      value: 'ZKTTF1700',
    },
  ],
  taskFilter: {
    assignedToMe: 1,
    createdByMe: 2,
    all: 3,
  },
  lookupsEnum: {
    member: 'Member',
    cashboxTransactionType: 'CashboxTransactionType',
    currency: 'Currency',
    status: 'Status',
  },
  statusesCategory: {
    membershipType: 'membership-type',
    membership: 'membership',
    classes: 'class',
    task: 'task',
    payment: 'payment',
    gate: 'gate',
    currency: 'currency',
    membershipCertificate: 'membership-certificate',
  },

  statusesCode: {
    membership: {
      active: 'active',
      frozen: 'frozen',
      canceled: 'canceled',
      expired: 'expired',
    },
    task: {
      pending: 'pending',
      done: 'done',
      canceled: 'canceled',
      onhold: 'onhold',
    },
    payment: {
      confirmed: 'confirmed',
      rejected: 'rejected',
    },
    class: {
      active: 'active',
    },
  },

  paymentMethodCode: {
    cheque: 'cheque',
    creditCard: 'credit-card',
    cash: 'cash',
  },
  transactionTypeCode: {
    open: 'open',
    close: 'close',
    withdraw: 'withdrawal',
  },
  // Session status values, matching the names the API serializes rather than an ordinal.
  registerSessionStatus: {
    open: 'Open',
    closed: 'Closed',
    forceClosed: 'ForceClosed',
  },
  recordType: {
    Members: {
      entity: 'Members',
      fieldName: 'ReferenceMemberId',
      fieldNameForObject: 'referenceMemberId',
    },
    Sales: {
      entity: 'Sales',
      fieldName: 'ReferenceSaleId',
      fieldNameForObject: 'referenceSaleId',
    },
    Payments: {
      entity: 'Payments',
      fieldName: 'ReferencePaymentId',
      fieldNameForObject: 'referencePaymentId',
    },
    Memberships: {
      entity: 'Memberships',
      fieldName: 'ReferenceMembershipId',
      fieldNameForObject: 'referenceMembershipId',
    },
    Expenses: {
      entity: 'Expenses',
      fieldName: 'ReferenceExpenseId',
      fieldNameForObject: 'referenceExpenseId',
    },
    Products: {
      entity: 'Products',
      fieldName: 'ReferenceProductId',
      fieldNameForObject: 'referenceProductId',
    },
    ProductTransactions: {
      entity: 'ProductTransactions',
      fieldName: 'ReferenceProductTransactionId',
      fieldNameForObject: 'referenceProductTransactionId',
    },
    Tasks: {
      entity: 'Tasks',
      fieldName: 'ReferenceTaskId',
      fieldNameForObject: 'referenceTaskId',
    },
    Notes: {
      entity: 'Notes',
      fieldName: 'ReferenceNoteId',
      fieldNameForObject: 'referenceNoteId',
    },
  },

  tabsMemberDetailsPopupValuesConst: {
    Memberships: {
      code: 'Memberships',
      nameEn: 'Memberships',
      nameAr: 'الاشتراكات',
      isEnable: true,
    },
    Payments: {
      code: 'Payments',
      nameEn: 'Payments',
      nameAr: 'المدفوعات',
      isEnable: false,
    },
    Sales: {
      code: 'Sales',
      nameEn: 'Sales',
      nameAr: 'المبيعات',
      isEnable: true,
    },
    Tasks: {
      code: 'Tasks',
      nameEn: 'Tasks',
      nameAr: 'المهام',
      isEnable: false,
    },
    // Activities: 'Activities',
    Entries: {
      code: 'Entries',
      nameEn: 'Entries',
      nameAr: 'الدخلات',
      isEnable: false,
    },
    Documents: {
      code: 'Documents',
      nameEn: 'Documents',
      nameAr: 'المستندات',
      isEnable: false,
    },
    Notes: {
      code: 'Notes',
      nameEn: 'Notes',
      nameAr: 'الملاحظات',
      isEnable: false,
    },
  },

  taskReference: {
    member: 0,
    membership: 1,
    saleOrder: 2,
    payment: 3,
    expense: 4,
    product: 5,
    productTransaction: 6,
    sale: 7,
  },

  paymentStatus: {
    confirmed: 'confirmed',
  },

  paymentTypeLst: [
    {
      isRefund: 1, id: 1, nameAr: 'اعادة مال', nameEn: 'Refund', code: 'Refund',
    },
    {
      isDiscount: 2, id: 2, nameAr: 'خصم', nameEn: 'Discount', code: 'Discount',
    },
    {
      isPayment: 3, id: 3, nameAr: 'دفعة', nameEn: 'Payment', code: 'Payment',
    },
    {
      isReversePayment: 4, id: 4, nameAr: 'دفعة مرتجعة', nameEn: 'Reverse Payment', code: 'ReversePayment',
    },
  ],
};
